import * as Types from '../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
export type UserTeaser = Pick<Types.User, 'id' | 'email' | 'givenName' | 'familyName' | 'enabled'>;

export const UserTeaser = gql`
  fragment UserTeaser on User {
    id
    email
    givenName
    familyName
    enabled
  }
`;
